export default "__VITE_ASSET__8eUWKDiO__"